<template>
  <div :class="['form-group', errors[attribute] ? 'has-error' : '']">
    <slot></slot>
    <p v-if="errors[attribute]" class="help-block">
      {{ errors[attribute][0] }}
    </p>
  </div>
</template>

<script>
    export default {
      props: ['errors', 'attribute'],
    };
</script>



// WEBPACK FOOTER //
// FormError.vue?1f17480e